import React, { createContext, useContext, useState } from 'react';
import { Snackbar } from '@material-ui/core';
import Alert, { Color } from '@material-ui/lab/Alert';

export const NotificationContext = createContext<{
    open: boolean,
    message: string,
    notify: (message: string, sev?: Color) => void
}>({
    open: false,
    message: "",
    notify: (message: string, sev?: Color) => {}
});

const NotificationContextProvider = ({ children }: any) => {
    const [message, setMessage] = useState<string>("");
    const [open, setOpen] = useState<boolean>(false);
    const [severity, setSeverity] = useState<Color>("success");

    const notify = (message: string, sev: Color = "success") => {
        setSeverity(sev);
        setMessage(message);
        setOpen(true);
    }

    return <NotificationContext.Provider value={{open, message, notify}}>
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
                }}
            onClose={() => {
                setOpen(false);
            }}
            autoHideDuration={6000}
            open={open}
        >
            <Alert severity={severity} elevation={6} variant="filled">
                {message}
            </Alert>
        </Snackbar>
        { children }
    </NotificationContext.Provider>
}

export default NotificationContextProvider;

export const useNotification = () => useContext(NotificationContext);